export default __webpack_public_path__ + "static/media/Avatar.66a1d816.svg";